export const parseCsv = (text: string): Record<string, string>[] => {
    const rows: string[][] = [];
    let row: string[] = [];
    let cell = '';
    let inQuotes = false;

    const pushCell = () => {
        row.push(cell);
        cell = '';
    };
    const pushRow = () => {
        if (row.length > 1 || (row.length === 1 && row[0])) {
            rows.push(row);
        }
        row = [];
    };

    const source = text.replace(/^\uFEFF/, '');
    for (let index = 0; index < source.length; index += 1) {
        const char = source[index];
        const next = source[index + 1];
        if (inQuotes) {
            if (char === '"' && next === '"') {
                cell += '"';
                index += 1;
            } else if (char === '"') {
                inQuotes = false;
            } else {
                cell += char;
            }
            continue;
        }
        if (char === '"') {
            inQuotes = true;
            continue;
        }
        if (char === ',') {
            pushCell();
            continue;
        }
        if (char === '\n' || char === '\r') {
            if (char === '\r' && next === '\n') {
                index += 1;
            }
            pushCell();
            pushRow();
            continue;
        }
        cell += char;
    }
    pushCell();
    pushRow();

    if (rows.length < 2) {
        return [];
    }
    const headers = rows[0].map((header) => header.trim());
    return rows.slice(1).map((values) => {
        const record: Record<string, string> = {};
        headers.forEach((header, index) => {
            if (header) {
                record[header] = (values[index] || '').trim();
            }
        });
        return record;
    });
};
